import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialCsrRateState: ICsrRateState = {
  data: {
    data: [],
    meta: {},
  },
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface ICsrRateState {
  data?: {
    data?: {[key: string]: number | string}[]
    meta: {[key: string]: number}
  }
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: ICsrRateState = initialCsrRateState,
  action: ActionWithPayload<ICsrRateState>
) => {
  switch (action.type) {
    //GET CSR Rate Data
    case actionTypes.GET_CSR_RATE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_CSR_RATE_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_CSR_RATE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add CSR Rate
    case actionTypes.ADD_CSR_RATE_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_CSR_RATE_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_CSR_RATE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_CSR_RATE_TYPE: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update CSR Rate
    case actionTypes.UPDATE_CSR_RATE_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_CSR_RATE_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_CSR_RATE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_CSR_RATE_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_CSR_RATE_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_CSR_RATE_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_CSR_RATE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_CSR_RATE_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_CSR_RATE_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_CSR_RATE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_CSR_RATE_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_CSR_RATE_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_CSR_RATE_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_CSR_RATE_SUCCESS: {
      const changedData: any = action.payload?.data?.data?.[0]
      let newData = state?.data?.data?.map((data) => {
        if (data?.id === changedData?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {
          data: newData,
          meta: state?.data?.meta,
        },
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_CSR_RATE_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_CSR_RATE_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_CSR_RATE_SUCCESS: {
      const changedData: any = action.payload?.data?.data?.[0]
      let newData = state?.data?.data?.map((data) => {
        if (data?.id === changedData?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {
          data: newData,
          meta: state?.data?.meta,
        },
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_CSR_RATE_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
      }
    }

    default:
      return state
  }
}
